import newsletterService from '@/services/api/newsletter/newsletterService';

export default {
  async subscribeEmail(_, email) {
    return await newsletterService.subscribeEmail(email);
  }
};
